import { createSlice } from "@reduxjs/toolkit";

// Which citation the user is currently viewing. Visi reports the click; the sources drawer and the
// width of the editor's Visi panel both read it, so it cannot live inside VisiContainer.
const initialState = {
  selectedCitationNumber: 0,
};

const citationsSlice = createSlice({
  name: "visiCitations",
  initialState,
  reducers: {
    setSelectedCitationNumber: (state, action) => {
      state.selectedCitationNumber = action.payload;
    },
    clearSelectedCitation: (state) => {
      state.selectedCitationNumber = 0;
    },
  },
});

export const { setSelectedCitationNumber, clearSelectedCitation } =
  citationsSlice.actions;

export const selectSelectedCitationNumber = (state) =>
  state.visi.citations.selectedCitationNumber;

export default citationsSlice.reducer;
